'use client';

import { MinimizedFooter as MinimizedFooterComponent } from '@monetization/hpaip-components-library';
import { useGetPartnerCompensation } from '@storefront/hooks/useGetPartnerCompensation';
import Script from 'next/script';

interface FooterProps {
  hpChannel: string;
}

export default function Footer({ hpChannel }: Readonly<FooterProps>) {
  const { data } = useGetPartnerCompensation(hpChannel);
  const validPartner: boolean =
    !!data?.getPartnerCompensation?.hp_attribution_id;

  return validPartner ? (
    <MinimizedFooterComponent />
  ) : (
    <Script
      strategy="afterInteractive"
      src="https://www.hp.com/caas/header-footer/us/en/default/latest.r?contentType=js"
    />
  );
}
